
import React from 'react'
import OceanBulkUpload from '../../../components/AWBDashboard/OceanBulkUpload';

const OceanCsvBulkUpload = () => {
 const [showAirBulk, setShowAirBulk] = React.useState(false);
  return (
    <div><OceanBulkUpload /></div>
  )
}

export default OceanCsvBulkUpload;
